import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';
import { UserService } from './user.service';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from './theme.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AppsSyncService {
  private tokenSubject: BehaviorSubject<string | null>;
  private userLangSubject: BehaviorSubject<string | null>;
  private userThemeSubject: BehaviorSubject<string | null>;

  constructor(
    private storageService: StorageService,
    private userService: UserService,
    private tr: TranslateService,
    private themeService: ThemeService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {
    this.tokenSubject = new BehaviorSubject<string | null>(this.storageService.getToken());

    this.userLangSubject = new BehaviorSubject<string | null>(this.storageService.getUserLang());

    this.userThemeSubject = new BehaviorSubject<string | null>(this.storageService.getUserTheme());

    if (isPlatformBrowser(this.platformId)) {
      this.monitorTabChange();
    }
  }

  private monitorTabChange(): void {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        const currentToken = this.storageService.getToken();
        const currentUserLang = this.storageService.getUserLang();
        const currentUserTheme = this.storageService.getUserTheme();

        if (currentToken !== this.tokenSubject.value) {
          this.tokenSubject.next(currentToken);

          if (currentToken) {
            this.userService.getUser();
          } else {
            this.userService.setAuthenticated(false);
          }
        }

        if (currentUserLang !== this.userLangSubject.value) {
          this.userLangSubject.next(currentUserLang);
          if (currentUserLang) {
            this.tr.use(currentUserLang);
          }
        }
        if (currentUserTheme && currentUserTheme !== this.userThemeSubject.value) {
          this.userThemeSubject.next(currentUserTheme);
          this.themeService.setTheme(currentUserTheme);
        }
      }
    });
  }
}
